import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
})
export class InputNumberComponent {
  @Input() placeholder: string = 'Enter number';
  @Input() label: string = '';
  @Input() size: 'default' | 'large' | 'small' = 'small';
  @Input() showClear: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() control: FormControl = new FormControl();

  clearInput() {
    this.control.setValue(null);
  }

  isRequired(control: AbstractControl | null): boolean {
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'] ? true : false;
  }
}
